import React from 'react';
//import PropTypes from 'prop-types';

import Avatar from '../user/avatar';
import Togglable from '../togglable';

const GoToTab = () => (
	<div className="align-items-center d-flex mt-3">
		<div className="flex-fill">
			<p className="text-hint">
				<em><small>Click a comment type tab to add a comment</small></em>
			</p>
		</div>
	</div>
)

const NewComment = Togglable(({ selected_type, user, allow_add, allow_comments, startComment })=>{
	if (selected_type === "all") {
		return <GoToTab />;
	}

	return <div className="align-items-center d-flex mt-3">
		<Avatar user={user} />
		<div className="flex-fill">
			<button className="btn btn-dark unsw-mw-0" type="button" onClick={()=>startComment(selected_type)}>
				<i aria-hidden="true" className="material-icons mr-2">add_comment</i>
				Add comment
			</button>
		</div>
	</div>
})

export default NewComment;